{% block ecocode_trustpilot_connect %}
<div class="ecocode-trustpilot-first-run-configure" >
            <ecocode-trustpilot-sales-channel-config ref="trustpilotConfig"  ></ecocode-trustpilot-sales-channel-config>
</div>
{% endblock %}
